var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"centerMap"},[_c('CustomizeChinaMapChart',{key:this.$store.state.query_flag+this.$store.state.date_value,staticClass:"centerMap__chart",attrs:{"embedded":"","id":"kfsl2","path":"clinic_kfsl_v2","params":{
      date_start: this.$store.state.date_value[0],
      date_end: this.$store.state.date_value[1],
      query_var: this.$store.state.query_var,
      query_cond: this.$store.state.query_cond,
      query_value: this.$store.state.query_value
    }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }